import { defineAsyncComponent } from 'vue'
export default {
  "layout-default": defineAsyncComponent(() => import("/app/apps/main-site/modern/src/shared/layouts/LayoutDefault.vue").then(m => m.default || m))
}